import React from "react";
import { useSearchParams } from "react-router-dom";
import { onImgErrorFallback } from "../../utils/mediaFallback";

function PreviewScreen() {
  const [searchParams] = useSearchParams();
  const url = searchParams.get("url");

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      {url && (
        <img
          src={url}
          alt="image"
          style={{ objectFit: "contain", height: "100vh" }}
          onError={onImgErrorFallback}
        />
      )}
    </div>
  );
}

export default PreviewScreen;
